import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class ordenCompraService {

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/orden-compra`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/orden-compra`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/excelDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/orden-compra/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async listarPorEstado(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/listar-por-estado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}logistica/orden-compra/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new ordenCompraService();